import io from 'socket.io-client';
import { Harpic, checkDocument, hasOwn } from '@buyhatke/custom-lib-js';

import { listNotifications, flushNotifications, getOTPToken } from '../../cred';

const listNotificationsLR = () => {
	let userAlertsLR = 0;

	if (checkDocument) {
		const localUserAlertsLR =
			window.localStorage.getItem('userAlerts') || 0; // user alert notif genesis time

		if (localUserAlertsLR) {
			try {
				userAlertsLR = JSON.parse(
					Harpic(decodeURIComponent(localUserAlertsLR))
				);
			} catch (err) {
				console.log(err);
			}
		}

		// try {
		// 	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(num => {
		// 		kukeej.remove(`readNotifications${num}`);
		// 	});
		// } catch (err) {
		// 	console.log(err);
		// }
	}
	return userAlertsLR;
};

const userAlertsMuteStatus = () => {
	let userAlertsMS = null;

	if (checkDocument) {
		userAlertsMS =
			window.localStorage.getItem('userAlertsMuted') === 'true' || false;
	}
	return userAlertsMS;
};

const getUserAlertLastShown = () => {
	let userAlertsLS = null;

	if (checkDocument) {
		userAlertsLS = window.localStorage.getItem('userAlertLastShown');
	}
	return userAlertsLS;
};

const getListNotifsSocketToken = async () => {
	try {
		const { status, data } = await getOTPToken();

		if (status === 1) {
			return data;
		}
	} catch (error) {
		console.log('getOTPToken', error);
	}
	return false;
};

let ioSocket = null;

const fetchUserAlertsFromSocket = async (getState, setState) => {
	try {
		const token = await getListNotifsSocketToken();

		if (token) {
			ioSocket = io(`https://wsorderv2.bitbns.com/?token=${token}`, {
				transports: ['websocket'],
			});

			ioSocket.on('connect_error', error => {
				console.log('connect_error', error);
			});

			// ioSocket.on('data', data => { // too slow
			// 	const { userAlerts, userAlertsLastRead } = getState();
			// 	if (data) {
			// 		try {
			// 			let userAlertsCount = 0;

			// 			const checkedData = data.filter(
			// 				notif =>
			// 					typeof notif.actions !== 'undefined' &&
			// 					notif.actions < 7
			// 			);

			// 			checkedData.reverse();
			// 			if (
			// 				(checkedData.length > 0 &&
			// 					userAlerts.length > 0 &&
			// 					checkedData[0].log_id ===
			// 						userAlerts[0].log_id) ||
			// 				(checkedData.length === 0 &&
			// 					userAlerts.length === 0)
			// 			) {
			// 				return;
			// 			}

			// 			/* const updatedDataForDeposit =  */ checkedData.forEach(
			// 				el => {
			// 					const { /* actions,  */ time } = el;
			// 					// let newTime = time;

			// 					// if (actions === 6) {
			// 					// 	newTime = new Date(
			// 					// 		new Date(time).getTime() + 39600000
			// 					// 	).toISOString();
			// 					// }
			// 					if (
			// 						new Date(time) / 1000 >
			// 						userAlertsLastRead
			// 					) {
			// 						userAlertsCount += 1;
			// 					}

			// 					// return {
			// 					// 	...el,
			// 					// 	// time: newTime,
			// 					// };
			// 				}
			// 			);

			// 			setState({
			// 				userAlerts: checkedData,
			// 				userAlertsCount,
			// 			});
			// 		} catch (error) {
			// 			console.log('fetchUAFromSocket__data', error);
			// 		}
			// 	}
			// });

			ioSocket.on('delta_data', data => {
				if (typeof data.actions !== 'undefined' && data.actions < 7) {
					const { userAlerts, userAlertsLastRead } = getState();

					const { actions, time, coinStr, order_id } = data;

					let newTime = time;

					let userAlertsCount = 0;

					if (actions === 6) {
						if (coinStr === 'INR') {
							if (
								String(order_id).startsWith('DEPOSIT_DROPLET')
							) {
								newTime = new Date(
									new Date(time).getTime() + 19800000
								).toISOString();
							} else {
								newTime = new Date(
									new Date(time).getTime() + 39600000
								).toISOString();
							}
						} else {
							newTime = new Date(
								new Date(time).getTime() + 19800000
							).toISOString();
						}
					}

					switch (actions) {
						case 4:
						case 5:
						case 6:
							// action(getBalances)();
							break;
						default:
							break;
					}

					if (new Date(time).getTime() / 1000 > userAlertsLastRead) {
						userAlertsCount += 1;
					}

					const item = {
						...data,
						time: newTime,
					};

					setState({
						userAlerts: [item, ...userAlerts],
						userAlertsCount,
					});
				}
			});
		}
	} catch (error) {
		console.log('getListNotifsSocketToken', error);
	}
};

const fetchUserAlerts = async (
	{ userAlerts, userAlertsLastRead },
	getState,
	setState
) => {
	try {
		const { status, data } = await listNotifications();
		// fetchUserAlertsFromSocket(userAlerts, userAlertsLastRead);
		if (status === 1 && data.length > 0) {
			let userAlertsCount = 0;
			const checkedData = data.filter(
				notif =>
					typeof notif.actions !== 'undefined' &&
					notif.actions < 7 &&
					notif.trade_amt !== null
			);

			checkedData.reverse();
			if (
				(checkedData.length > 0 &&
					userAlerts.length > 0 &&
					checkedData[0].log_id === userAlerts[0].log_id) ||
				(checkedData.length === 0 && userAlerts.length === 0)
			) {
				return {};
			}

			const updatedDataForDeposit = checkedData
				.map(el => {
					const { actions, time, coinStr, order_id } = el;
					let newTime = time;

					if (actions === 6) {
						if (coinStr === 'INR') {
							if (
								String(order_id).startsWith('DEPOSIT_DROPLET')
							) {
								newTime = new Date(
									new Date(time).getTime() + 19800000
								).toISOString();
							} else {
								newTime = new Date(
									new Date(time).getTime() + 39600000
								).toISOString();
							}
						} else {
							newTime = new Date(
								new Date(time).getTime() + 19800000
							).toISOString();
						}
					}

					if (new Date(time).getTime() / 1000 > userAlertsLastRead) {
						userAlertsCount += 1;
					}

					return {
						...el,
						time: newTime,
					};
				})
				.sort((a, b) => {
					if (new Date(a.time) > new Date(b.time)) {
						return -1;
					}
					return 1;
				});
			fetchUserAlertsFromSocket(getState, setState);
			return {
				userAlerts: updatedDataForDeposit,
				userAlertsLastRead,
				userAlertsCount,
			};
		}
	} catch (error) {
		console.log('useralerts', error);
	}
	return {};
};

const flushUserAlerts = async (_, alertMsg) => {
	try {
		const { status, msg } = await flushNotifications();

		if (status === 1) {
			window.localStorage.removeItem('userAlerts');
			window.localStorage.removeItem('userAlertLastShown');

			return {
				userAlertsCount: 0,
				userAlertsLastRead: 0,
				userAlerts: [],
				userAlertLastShown: null,
			};
		}

		alertMsg('Error', msg);
	} catch (error) {
		console.log('useralerts flush', error);
	}
	return {};
};

const setUserAlertsRead = ({
	userAlerts,
	userAlertsLastRead: userAlertsLRCurr,
}) => {
	let userAlertsLastRead = userAlertsLRCurr;

	if (checkDocument) {
		if (userAlerts.length > 0 && hasOwn(userAlerts[0], 'time')) {
			userAlertsLastRead = new Date(userAlerts[0].time).getTime() / 1000;
			window.localStorage.setItem('userAlerts', userAlertsLastRead);
		}
	}
	return {
		userAlertsCount: 0,
		userAlertsLastRead,
	};
};

const setUserAlertLastShown = (_, id) => {
	let userAlertLastShown = null;

	if (checkDocument) {
		userAlertLastShown = id;
		window.localStorage.setItem('userAlertLastShown', id);
	}

	return {
		userAlertLastShown,
	};
};

const toggleUserAlerts = ({ userAlertsMuted }) => {
	const newUserAlertsMuted = !userAlertsMuted;

	if (checkDocument) {
		window.localStorage.setItem('userAlertsMuted', newUserAlertsMuted);
	}

	return {
		userAlertsMuted: newUserAlertsMuted,
	};
};

export const initialUserAlerts = {
	userAlerts: [],
	userAlertsCount: 0,
	userAlertsLastRead: listNotificationsLR(),
	userAlertsMuted: userAlertsMuteStatus(),
	userAlertLastShown: getUserAlertLastShown(),
};

const killUserAlerts = () => {
	if (ioSocket) {
		ioSocket.close();
		ioSocket = null;
	}
	return initialUserAlerts;
};

export const userAlertActions = ({ setState, getState }) => ({
	/**
	 * checkFor User Alerts
	 */
	__fetchUserAlerts: state => fetchUserAlerts(state, getState, setState),
	__resetUserAlerts: killUserAlerts,
	__setUserAlertsRead: setUserAlertsRead,
	__flushUserAlerts: flushUserAlerts,
	__toggleUserAlerts: toggleUserAlerts,
	__setUserAlertLastShown: setUserAlertLastShown,
});
